import { useCallback, useEffect, useState } from "react";
import dayjs from "dayjs";

import {
  getLapseRunsApi,
  LapseRun,
} from "../services/Admin/LapseRunApis";

const POLL_MS = 45000;

export const formatPendingLapseSummary = (run: LapseRun) => {
  const included =
    run.includedCount ??
    Math.max((run.proposedCount ?? 0) - (run.excludedCount ?? 0), 0);
  const created = run.createdAt
    ? dayjs(run.createdAt).format("YYYY-MM-DD HH:mm")
    : "—";
  const group = run.OwningGroup?.GroupName;
  return {
    title: `Lapse run #${run.id}${group ? ` · ${group}` : ""}`,
    description: `Proposed ${run.proposedCount ?? 0} · Included ${included} · Excluded ${run.excludedCount ?? 0} · ${created}`,
  };
};

export const usePendingLapseRuns = (enabled: boolean) => {
  const [pendingRuns, setPendingRuns] = useState<LapseRun[]>([]);
  const [loading, setLoading] = useState(false);

  const reload = useCallback(() => {
    if (!enabled) {
      setPendingRuns([]);
      return Promise.resolve();
    }
    setLoading(true);
    return getLapseRunsApi("PENDING")
      .then((res) => {
        if (!res || res.success === false) {
          setPendingRuns([]);
          return;
        }
        setPendingRuns(Array.isArray(res.data) ? res.data : []);
      })
      .catch(() => setPendingRuns([]))
      .finally(() => setLoading(false));
  }, [enabled]);

  useEffect(() => {
    if (!enabled) {
      setPendingRuns([]);
      return;
    }
    reload();
    const interval = window.setInterval(() => reload(), POLL_MS);
    return () => window.clearInterval(interval);
  }, [enabled, reload]);

  return {
    pendingRuns,
    pendingCount: pendingRuns.length,
    loading,
    reload,
  };
};
